import React from 'react';
import { Layer, Source } from 'react-map-gl';

import { metersToPixelsAtMaxZoom } from 'utils/helpers';
interface IJobRadiusProps {
  latitude: number;
  longitude: number;
  radius: number;
  sourceId?: string;
  circleId?: string;
}

const JobRadius: React.FC<IJobRadiusProps> = ({
  latitude,
  longitude,
  radius,
  sourceId = 'my-data',
  circleId = 'radius',
}) => {
  return (
    <Source
      id={sourceId}
      type="geojson"
      data={{
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
      }}
    >
      <Layer
        id={circleId}
        type="circle"
        paint={{
          'circle-radius': {
            stops: [
              [0, 0],
              [20, metersToPixelsAtMaxZoom(radius, latitude)],
            ],
            base: 2,
          },
          'circle-color': '#2a2f5a',
          'circle-opacity': 0.6,
        }}
      />
    </Source>
  );
};

export default JobRadius;
